'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = collectionTransform;

var _findIndex = require('./utils/findIndex');

var _findIndex2 = _interopRequireDefault(_findIndex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getPreviousData(previous) {
  return previous && previous.data && previous.data.slice(0) || [];
}

function collectionTransform(payload, previous, isFulfilled) {
  var meta = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var action = meta.action,
      definition = meta.definition,
      inputData = meta.inputData;


  var getId = function getId(data) {
    return data[definition ? definition.idAttribute : 'id'];
  };

  function create() {
    if (!isFulfilled) return previous;

    var data = getPreviousData(previous);
    data.push(payload.data);

    return _extends({}, previous, { data: data });
  }

  function update() {
    if (!isFulfilled || !inputData) return previous;

    var data = getPreviousData(previous);
    var index = (0, _findIndex2.default)(data, function (x) {
      return getId(x) === getId(inputData);
    });
    if (index >= 0) {
      data[index] = _extends({}, data[index], payload.data);
    }

    return _extends({}, payload, { data: data });
  }

  function destroy() {
    if (!inputData) return previous;

    var data = getPreviousData(previous);
    if (isFulfilled) {
      data = data.filter(function (x) {
        return getId(x) !== getId(inputData);
      });
      return _extends({}, payload, { data: data });
    }

    var index = (0, _findIndex2.default)(data, function (x) {
      return getId(x) === getId(inputData);
    });
    if (index >= 0) {
      data[index] = _extends({}, data[index], { pendingDelete: true });
    }

    return _extends({}, previous, { data: data });
  }

  switch (action) {
    case 'create':
      return create();
    case 'update':
      return update();
    case 'destroy':
      return destroy();
    default:
      return isFulfilled ? payload : previous;
  }
}


//////////////////
// WEBPACK FOOTER
// ../dist/collectionTransform.js
// module id = 330
// module chunks = 0